import request from '@/utils/request'

let StatisticsApi = {
  /*订单数据统计*/
  getOrderTotal(data) {
    return request._post('/shop/statistics.sales/index', data);
  },
  /*订单时间段统计*/
  getOrderByDate(data) {
    return request._post('/shop/statistics.sales/order', data);
  },
  /*商品时间段统计*/
  getProductByDate(data) {
    return request._post('/shop/statistics.sales/product', data);
  },
  /*会员数据统计*/
  getUserTotal(data) {
    return request._post('/shop/statistics.user/index', data);
  },
  /*成交占比*/
  getUserScale(data) {
    return request._post('/shop/statistics.user/scale', data);
  },
  /*新增会员*/
  getNewUser(data) {
    return request._post('/shop/statistics.user/new_user', data);
  },
  /*成交会员数*/
  getPayUser(data) {
    return request._post('/shop/statistics.user/pay_user', data);
  },
  /*成交会员数*/
  getMonthExpense(data) {
    return request._post('/shop/statistics.user/getMonthExpense', data);
  },
   /*业务员*/
  getSaler(data) {
    return request._post('/shop/statistics.user/getSaler', data);
  },
  /*成交会员数*/
  getYearExpense(data) {
    return request._post('/shop/statistics.user/getYearExpense', data);
  },
  getProductSales(data) {
    return request._post('/shop/statistics.productsales/index', data);
  },
  getsupplySales(data) {
    return request._post('/shop/statistics.productsales/supplysales', data);
  },
  getSupply(data){
    return request._post('/shop/store.Store/index', data);
  },
  orderStatistics(data){
    return request._post('/shop/statistics.Order/orderStatistics', data);
  },
  //获取供应商货款
  getSupplyMoney(data) {
    return request._post('/shop/statistics.supplyMoney/index', data);
  },
  //获取佣金src\views\statistics\usercommission\index.vue
  getUserCommission(data) {
    return request._post('/shop/statistics.userCommission/index', data);
  },
//获取各个阶段的业绩统计 
getAchievement(data) {
  return request._post('/shop/statistics.achievement/achievement', data);
},
//获取各个阶段的订单统计 
getOrder(data) {
  return request._post('/shop/statistics.order/order', data);
},

ywy_index(data) {
  return request._post('/shop/statistics.Ywy/index', data);
},

//核销
  getVoucherStatistics(data) {
    return request._post('/shop/statistics.voucher/statistics', data)
  },
  
  // 获取核销列表
  getVoucherList(data) {
    return request._post('/shop/statistics.voucher/list', data)
  },
  
  // 获取商家汇总数据
  getMerchantSummary(data) {
    return request._post('/shop/statistics.voucher/merchant_summary', data)
  },
  
  // 核销操作
  verifyVoucher(data) {
    return request._post('/shop/statistics.voucher/verify', data)
  },
  
  // 导出数据
  exportVoucherData(data) {
    return request._post('/shop/statistics.voucher/export', data)
  },
 getMerchantList(data) {
    return request._post('/shop/statistics.voucher/getMerchantList', data)
  }

}

export default StatisticsApi;



// WEBPACK FOOTER //
// ./src/api/statistics.js